import { render } from "./Perfil.vue?vue&type=template&id=441225ba&scoped=true&ts=true"
import script from "./Perfil.vue?vue&type=script&lang=ts"
export * from "./Perfil.vue?vue&type=script&lang=ts"

import "./Perfil.vue?vue&type=style&index=0&id=441225ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441225ba"]])

export default __exports__